module.exports = __webpack_public_path__ + "static/img/h-i-6.dfbf7bc1.png";